export const environment = {
  production: true,
  serviceName: '',
  baseHref: '/',
};
